import React from 'react';
import config from '@config';
import { BOTTOM_INDENTS, COLORS, TOP_INDENTS } from '@constants';
import { Button, Divider, Icon, Tag, Typography } from '@ui';
import { Card, Flex } from 'antd';
import { LogoConnector } from '../../../../ui/LogoConnector';
import { StyledFlex, StyledWrapper } from '../../styled';

const NotConnected = () => {
    return (
        <StyledWrapper>
            <StyledFlex align='center' justify='space-between'>
                <LogoConnector />
                <Button
                    style={{ width: 160 }}
                    type='primary'
                    onClick={() => {
                        const win = window.open(config.appUrl + '/register', '_blank', 'noopener,noreferrer');
                        if (win) win.opener = null;
                    }}
                >
                    Visit Klickly
                </Button>
            </StyledFlex>
            <Divider margin={0} />
            <Card style={{ ...TOP_INDENTS.XL_PLUS, ...BOTTOM_INDENTS.XL_PLUS }}>
                <Flex align='center' justify='space-between' gap={16}>
                    <Flex gap={16} align='center'>
                        <Icon color={COLORS.$gray60Black} size='80px' component={() => <Icon.CampaignIcon />} />
                        <Flex vertical>
                            <Typography.Text marginBottom='8px' type='badgeLarge'>
                                App connection status
                            </Typography.Text>
                            <Typography.Text color={COLORS.$gray60Black} type='body2'>
                                A matching Klickly advertising account could not be found. Please create a Klickly
                                account or contact us if you believe this is an error.
                            </Typography.Text>
                        </Flex>
                    </Flex>
                    <Tag color={COLORS.$tartRed}>
                        <Typography.Text type='badgeSmall' color={COLORS.$white}>
                            Not Connected
                        </Typography.Text>
                    </Tag>
                </Flex>
            </Card>
        </StyledWrapper>
    );
};

export default NotConnected;
